import { useEffect } from 'react'
import { callAPI } from '../hooks/api'
import { useState } from 'react'
import { geojsonToWKT } from '@terraformer/wkt'
import Spinner from './Spinner'
import SoilDetailModal from './SoilDetailModal'

export default function SoilData({
  soilData,
  localAuth,
  isDemoUser,
}) {
  const [loading, setLoading] = useState(false)
  const [soilDetail, setSoilDetail] = useState('')
  const [soilType, setSoilType] = useState('')
  const [showSoilDetailModal, setShowSoilDetailModal] = useState(false)

  async function getSoilDetail(soilType) {
    setLoading(true)
    var endpoint = '/query_soils_detail_ucdavis'
    var params = {
      series_name: soilType,
      session_key: localAuth.sessionKey,
    }

    var res = await callAPI(endpoint, params)
    setLoading(false)
    if (res.status === 'success') {
      setSoilDetail(res.detail)
      setSoilType(soilType)
      setShowSoilDetailModal(true)
    }
  }
  if (loading) {
    return <Spinner local={true} />
  }

  if (soilData.length === 0)
    return (
      <p className="ml-[30px] ">
        <span className={`${isDemoUser ? 'blur' : ''}`}>
          No Soil data for this parcel
        </span>
      </p>
    )
  else
    return (
      <>
        {showSoilDetailModal && (
          <SoilDetailModal
            soilType={soilType}
            soilDetail={soilDetail}
            showSoilDetailModal={showSoilDetailModal}
            setShowSoilDetailModal={setShowSoilDetailModal}
          />
        )}

        <table
          className="mt-2 mb-5"
          style={{ width: '100%', tableLayout: 'fixed' }}
        >
          <thead>
            <tr>
              <th
                style={{ paddingLeft: '50px', width: '25%', textAlign: 'left' }}
              >
                Common Name
              </th>
              <th style={{ width: '25%', textAlign: 'center' }}>Percent Coverage</th>              
              <th style={{ width: '25%', textAlign: 'center' }}>Non-Irrigated Land Capability Class</th>              
              <th style={{ width: '25%', textAlign: 'center' }}>Drainage Class</th>
            </tr>
          </thead>
          <tbody>
            {soilData.map((soil) => (
              <tr key={soil["Common Name"]}>
                <td
                  className="items-center"
                  style={{ paddingLeft: '50px', textAlign: 'left' }}
                >
                  <div
                    onClick={() => {
                      if (!isDemoUser) getSoilDetail(soil["Common Name"])
                    }}
                    className="cursor-pointer text-cyan-900"
                  >
                    <span className={`${isDemoUser ? 'blur' : ''}`}>
                      {soil["Common Name"]}
                    </span>
                  </div>
                </td>
                <td className="items-center" style={{ textAlign: 'center' }}>
                  <span className={`${isDemoUser ? 'blur' : ''}`}>
                    {soil.pct_cov} %
                  </span>
                </td>
                <td className="items-center" style={{ textAlign: 'center' }}>
                  <span className={`${isDemoUser ? 'blur' : ''}`}>
                    {soil['Non-Irrigated Land Capability Class']}{soil['Non-Irrigated Land Capability Subclass']}
                  </span>
                </td>
                <td className="items-center" style={{ textAlign: 'center' }}>
                  <span className={`${isDemoUser ? 'blur' : ''}`}>
                    {soil["Drainage Class"]}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    )
}
